import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserRole, selectIsAuthenticated } from '../../../store/slices/authSlice';
import { ROLES } from '../../../api/constants';
import ErrorLayout from '../components/ErrorLayout';
import { useThemeContext } from '../../../components/ThemeProvider';

const Error404 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = useSelector(selectUserRole);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const { primaryColor } = useThemeContext();

  // Determine where to redirect based on auth state
  const getRedirectPath = () => {
    if (!isAuthenticated) return '/login';
    
    if (userRole === ROLES.ADMIN) {
      return '/admin/dashboard';
    }
    return '/user/dashboard';
  };

  const handleGoBack = () => {
    // Try to go back in history, otherwise go to dashboard/login
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(getRedirectPath(), { replace: true });
    }
  };

  const handleGoHome = () => {
    navigate(getRedirectPath(), { replace: true });
  };

  return (
    <ErrorLayout
      code={404}
      title="Sayfa Bulunamadı"
      message={`"${location.pathname}" adresi bulunamadı. Link bozuk veya sayfa kaldırılmış olabilir.`}
      action={
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button 
            onClick={handleGoBack}
            className="px-6 py-3 rounded-lg text-gray-700 dark:text-gray-200 font-medium border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
          >
            Geri Dön
          </button>
          <button 
            onClick={handleGoHome}
            className="px-6 py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity"
            style={{ backgroundColor: primaryColor || '#1E40AF' }}
          >
            {isAuthenticated ? 'Dashboard\'a Git' : 'Giriş Yap'}
          </button>
        </div>
      }
    />
  );
};

export default Error404;


